import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { useContactButtonLabel } from "../hooks/useContactButtonLabel";
import { contactFormSubmitTestId } from "./constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const ContactFormSubmit = ({ loading }) => {
    const contactButtonLabel = useContactButtonLabel();
    const isPreviewMode = useIsPreviewMode();
    return (_jsx(Button, { isDisabled: loading || isPreviewMode, isLoading: loading, testId: contactFormSubmitTestId, isFullWidth: true, type: "submit", children: contactButtonLabel }));
};
